import {useEffect, useState } from "react";
import ReportBars from "../../../components/chart-bars/ReportBars";
import "../../../styles/Report.css";
import { base_url } from "../../../utils/apiConfig";
import axios from "axios";
import { Button, Card, Col, Row, Spin } from "antd";
import { Link } from "react-router-dom";
import newStyled from "@emotion/styled";
import { Outlet } from "react-router-dom";

const Report = ({ storeData }) => {
  const [auditStoreData, setAuditStoreData] = useState(null);
  const queDataListId = storeData?.id;
  const [auditStoreDataLoading, setAuditStoreDataLoading] = useState(false);

  useEffect(() => {
    if (queDataListId) {
      const fetchAuditStoreReportData = async () => {
        setAuditStoreDataLoading(true);
        try {
          const authToken = localStorage.getItem("authToken");
          const response = await axios.get(
            `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/store/${queDataListId}/audit_store`,
            {
              headers: {
                Authorization: `token ${authToken}`,
                "Content-Type": "application/json",
              },
            }
          );
          setAuditStoreData(response.data);
        } catch (error) {
          console.log("Something wrong fetching marking graph data:", error);
        } finally {
          setAuditStoreDataLoading(false);
        }
      };
      fetchAuditStoreReportData();
    }
  }, [queDataListId]);

  const getProgressColor = (colorCode) => {
    switch (colorCode) {
      case 1:
        return "rgb(205, 92, 92)";
      case 2:
        return "rgb(255, 127, 80)";
      case 3:
        return "#C6B83F";
      case 4:
        return "rgb(126, 204, 1)";
      case 5:
        return "rgb(126, 204, 1)";
      default:
        return "#007dc1";
    }
  };

  return (
    <div
      style={{ backgroundColor: "#FAFAFA" }}
      className="reo my-4 px-4 minHtForTbl"
    >
      <div className="audit-details">
        <p className="ms-2">Type of Audit</p>
      </div>
      <Row gutter={[16, 16]} className="survey-cards mx-auto my-3">
        {auditStoreDataLoading ? (
          <Col span={24} className="text-center">
            <Spin style={{ padding: "8rem 4rem" }} />
          </Col>) : Array.isArray(auditStoreData) && auditStoreData.length > 0 ? (
            auditStoreData.map((report) => (
              <Col
                key={report.id}
                xs={24}
                sm={12}
                md={12}
                lg={8}
                xl={8}
                xxl={6}
                xxxl={6}
                className="d-flex justify-content-center"
              >
                <CardStyle
                  className="shadow-lg"
                  title={report?.audit?.audit_cycle?.name || "No Type of Audit"}
                  // bordered={false}
                  variant="borderless"
                  style={{
                    borderRadius: "10px",
                    maxWidth: "390px",
                    minHeight: "320px",
                  }}
                >
                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <p className="a-left">Audit Type</p>
                    </Col>
                    <Col span={16}>
                      <p className="a-right">
                        {report?.audit?.audit_cycle?.type || "No Audit"}
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <p className="a-left">Audit Date</p>
                    </Col>
                    <Col span={16}>
                      <p className="a-right">{report?.audit_date || "No Date"}</p>
                    </Col>
                  </Row>
                  <div className="dashed-bar df">
                    <ReportBars
                      color={getProgressColor(report?.color || "#8DC63F")}
                      progress={report?.audit_store_percentage || 0}
                      shadow={false}
                    />
                  </div>
                  <div>
                    <Link to={`/auditReport/${report.id}`} target="_blank">
                      <Button
                        style={{ color: "#fff", fontWeight: 500 }}
                        className="viewReport"
                      >
                        View Report
                      </Button>
                    </Link>
                  </div>
                </CardStyle>
              </Col>
            ))
          ) : (
          <Col span={24} className="text-center noDataText">
            No Data is available
          </Col>
        )}
      </Row>
      <Outlet />
    </div>
  );
};

const CardStyle = newStyled(Card)`
:where(.css-dev-only-do-not-override-1kf000u).ant-card .ant-card-head{
 color:#003c5d;
 font-size:20px !important;
 font-weight: 500;
 font-family:Roboto !important;
 }
`;
export default Report;
